import ContractDistributionsService from "@/api/services/contractDistributions";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
  keywords: "",
  availableFilters: {
    insurers: [],
    status: [
      { label: "Activé", value: true },
      { label: "Désactivé", value: false },
    ],
  },
  selectedFilters: {
    insurers: [],
    status: [],
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.contractDistributions;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
    setAvailableFilters(state, { filterName, options }) {
      state.availableFilters[filterName] = options;
    },
    setFilter(state, { filterName, filterOptions }) {
      state.selectedFilters[filterName] = filterOptions;
    },
    setKeywords(state, keywords) {
      state.keywords = keywords;
    },
  },
  actions: {
    async fetchIndex({ commit }, { save = true, includes = [], ...params } = {}) {
      const response = await ContractDistributionsService.fetchIndex(params, includes);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      if (save) commit("setIndex", data);
      return data;
    },
    async fetch(_, { id, includes = [] } = {}) {
      const response = await ContractDistributionsService.fetch(id, includes);
      if (!response?.success) return response;

      return toCamelCase(response.data);
    },
    async update(_, { id, data }) {
      const response = await ContractDistributionsService.update(id, data);
      if (!response?.success) return response;

      return response;
    },
  },
};
